module.exports = __webpack_public_path__ + "assets/img/loopholes.7cf926ed.svg";